import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export function usePortalSettings() {
  return useQuery({
    queryKey: ['portal-settings'],
    queryFn: () => apiClient.get('/settings'),
  });
}

export function useUpdateSetting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, value }: { key: string; value: any }) =>
      apiClient.put(`/settings/${key}`, { value }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['portal-settings'] });
    },
  });
}

export function useSendTestEmail() {
  return useMutation({
    mutationFn: (to: string) => apiClient.post('/settings/test-email', { to }),
  });
}
